import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/docgen/statusmessage'
import pathMap from 'src/paths/pathMap'

class StatusMessageRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.STATUS_MESSAGE_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.STATUS_MESSAGE_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.STATUS_MESSAGE_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.STATUS_MESSAGE_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default StatusMessageRoute
